<template>
  <v-content>
    <v-container fill-height>
      <v-layout align-center>
        <v-flex text-xs-center>
          <h1 class="display-2 secondary--text">Whoops, {{pageData.codice}}</h1>
          <p>{{pageData.message}}</p>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
export default {
  name: "p-404",
  computed: {
    pageData() {
      return this.$store.getters.getPageData;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// modules/Home/views/src/pages/404.vue